import React, {useEffect, useState} from 'react';
import {FormCardTransition, FormCardVariants} from 'styles/styled';
import VerifyWrapper from "../../components/verifyWrapper";
import {motion} from "framer-motion";
import {useSelector} from "react-redux";
import {RootState} from "../../store";
import {businessOnlyDest, personalOnlyDest} from "../../util/constants";
import PersonalOnly from "./personalOnly";
import SelectAccountType from "./selectAccountType";
import BusinessOnly from "./businessOnly";
import useDocumentTitle from "../../util/hooks/useDocumentTitle";

const Signup = () => {

  useDocumentTitle('Signup');
  const queryParams = useSelector((state: RootState) => state.app.queryParams);
  const [signupType, setSignupType] = useState<JSX.Element>(<SelectAccountType/>);

  useEffect(() => {
    if(personalOnlyDest.includes(queryParams.dest)) {
      setSignupType(<PersonalOnly/>);
    } else if (businessOnlyDest.includes(queryParams.dest)) {
      setSignupType(<BusinessOnly/>);
    }
  }, [queryParams])


  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      transition={FormCardTransition}
      variants={FormCardVariants}
    >
      <VerifyWrapper>
        {signupType}
      </VerifyWrapper>
    </motion.div>

  );
};

export default Signup;
